import { createSelector } from 'reselect';

import { AppState } from '../../../../store/models/app-state';

export const bonusSettlementsState = (state: AppState) => state.bonusSettlements;

export const bonusSettlementsSelector = createSelector(bonusSettlementsState, state => state.overview.bonusSettlements);
export const bonusSettlementsRequestingSelector = createSelector(
    bonusSettlementsState,
    state => state.overview.requesting
);
